class ScrollButton {
    constructor(button) {
        const target = document.querySelector('#' + button.dataset.z21ScrollButtonTarget);
        button.addEventListener('click', this.scroll.bind(this, button, target));
    }

    scroll(button, target) {
        if (button.dataset.z21ScrollButtonDirection === 'left') {
            target.scrollBy({
                top: 0,
                left: -(Math.min(target.clientWidth, 1300)),
                behavior: 'smooth',
            });
        } else {
            target.scrollBy({
                top: 0,
                left: Math.min(target.clientWidth, 1300),
                behavior: 'smooth',
            });
        }
    }
}

(function () {
    'use strict';

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run, {once: true});
    } else {
        run();
    }

    function run() {
        initScrollButton();
    }

    function initScrollButton() {
        const scrollButtons = document.querySelectorAll('[data-z21-scroll-button-target]');

        for (const button of scrollButtons) {
            new ScrollButton(button);
        }
    }

})();
